module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-banner lo-container"
  }, [_c('div', {
    staticClass: "lo-12 lo-6-sm _h-100pct _pdt-0px-sm"
  }, [_c('div', {
    staticClass: "_als-ct _jtfs-ct _cl-white _tal-ct _tal-l-sm"
  }, [_c('h1', [_vm._v("Biomatic UI")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Introduction'
      }
    }
  }, [_c('div', {
    staticClass: "bio-button -accent u-rise _w-256px _mgbt-8px _dp-ilb _dp-b-sm"
  }, [_c('strong', [_vm._v("เริ่มใช้งาน")])])]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-4"
  }, [_vm._v("\n        CSS Framework ที่ง่าย และคล่องตัวที่สุด "), _c('br'), _vm._v("\n        สำหรับทุกโปรเจคของคุณ\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('small', [_vm._v("เวอร์ชั่นล่าสุด 0.1.17")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_als-e _jtfs-ct _dp-n _dp-b-sm"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/home/phone.svg"),
      "height": "400",
      "alt": "hero-image"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5257a730","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/home/HomeBanner.vue
// module id = 131
// module chunks = 0